export default "__VITE_ASSET__DrFl_x7i__"